import React from 'react';
import ReactDOM from 'react-dom';
import './app/index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/system';
import { createTheme } from '@mui/material/styles';
import { Provider } from './context';
import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en.json'
import ru from 'javascript-time-ago/locale/ru.json'

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#1D1761',
    },
    secondary: {
      main: '#02B28E',
      contrastText: '#FFFFFF'
    },
    white: {
      main: '#FFFFFF',
    },
    grey: {
      main: '#888888',
    },
    greyPrimary: {
      main: '#242333',
      contrastText: '#ffffff'
    },
    lightblue: {
      main: '#E3E8EF',
      contrastText: '#1D1761'
    },
    whiteNav: {
      main: '#FFFFFF',
      contrastText: '#242333'
    },
    lightPrimary: {
      main: '#E8E7EF',
      contrastText: '#1D1761'
    },
    lightSecondary: {
      main: '#E5F7F3',
      contrastText: '#02B28E'
    },
    skyBlue: {
      main: '#E5F4FF',
      contrastText: '#0090FF'
    },
    redButton: {
      main: '#FFFFFF',
      contrastText: '#FF4848'
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      '"Sora"',
      '"Readex Pro"',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          //backgroundColor: '#EEF2F8',
          borderColor: '#C7D2E1',
          fontSize: '14px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px'
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          fontSize: '14px',
          borderRadius: 10,
          textTransform: "none",
          boxShadow: '0 0 0 0'
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 1
      },
      variants: [
        {
          props: {
            variant: 'round',
          },
          style: {
            borderRadius: 16,
            boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 3%), 0px 1px 1px 0px rgb(0 0 0 / 3%), 0px 1px 3px 0px rgb(0 0 0 / 3%)'
          },
        },
      ]
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#EEF2F8'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#242333'
        }
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        ListboxProps: {
          sx: { fontSize: '14px' }
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1200,
      xl: 1536,
      tablet: 830
    },
  },
};
const theme = createTheme(themeOptions);


TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);
ReactDOM.render(
  <Provider>
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
